<div class="row recharge-footer" id="ccmrecharge">
  <h1 class="col-12 clem-recharge-font"><b>{{ 'RECHARGE.MARCHE.TITLE' | translate }}</b></h1>

  <div [ngSwitch]="getSite()" class="col-11 step-1">


    <!-- Default -->
    <div *ngSwitchDefault class="row">
      <div class="col-md-3 col-12">
        <div class="row ccm-content justify-content-around  ">
          <div class="col-8">
            <img src="../../../assets/img/Recharge/CCM/PictoRecharge_Inscription.svg" alt="">
            <h4>
              {{ 'RECHARGE.MARCHE.PARA1' | translate }}
            </h4>
          </div>
        </div>
      </div>
      <div class="col-md-3 col-12">
        <div class="row ccm-content justify-content-around  ">
          <div class="col-8">
            <img src="../../../assets/img/Recharge/CCM/PictoRecharge_Reservation.svg" alt="">
            <h4>
              {{ 'RECHARGE.MARCHE.PARA2' | translate }}
            </h4>
          </div>
        </div>
      </div>
      <div class="col-md-3 col-12">
        <div class="row ccm-content justify-content-around  ">
          <div class="col-8">
            <img src="../../../assets/img/Recharge/CCM/PictoRecharge_BorneResa.svg" alt="">
            <h4>
              {{ 'RECHARGE.MARCHE.PARA3' | translate }}
            </h4>
          </div>
        </div>
      </div>
      <div class="col-md-3 col-12">
        <div class="row ccm-content justify-content-around  ">
          <div class="col-8">
            <img src="../../../assets/img/Recharge/CCM/PictoRecharge_ChargeVoiture.svg" alt="">
            <h4>
              {{ 'RECHARGE.MARCHE.PARA4' | translate }}
            </h4>
          </div>
        </div>
      </div>
    </div>

    <!-- REMI -->
     <div *ngSwitchCase="'remi'" class="row">
      <div class="col-md-3 col-12">
        <div class="row ccm-content justify-content-around  ">
          <div class="col-8">
            <img src="../../../assets/img/Remi/svg/1.svg" alt="">
            <h4>
              {{ 'RECHARGE.MARCHE.PARA1' | translate }}
            </h4>
          </div>
        </div>
      </div>
      <div class="col-md-3 col-12">
        <div class="row ccm-content justify-content-around  ">
          <div class="col-8">
            <img src="../../../assets/img/Remi/svg/2.svg" alt="">
            <h4>
              {{ 'RECHARGE.MARCHE.PARA2' | translate }}
            </h4>
          </div>
        </div>
      </div>
      <div class="col-md-3 col-12">
        <div class="row ccm-content justify-content-around  ">
          <div class="col-8">
            <img src="../../../assets/img/Remi/svg/3.svg" alt="">
            <h4>
              {{ 'RECHARGE.MARCHE.PARA3' | translate }}
            </h4>
          </div>
        </div>
      </div>
      <div class="col-md-3 col-12">
        <div class="row ccm-content justify-content-around  ">
          <div class="col-8">
            <img src="../../../assets/img/Remi/svg/4r.svg" alt="">
            <h4>
              {{ 'RECHARGE.MARCHE.PARA4' | translate }}
            </h4>
          </div>
        </div>
      </div>
    </div>



  </div>

</div>

